import { Component, OnInit } from '@angular/core';
import { LeadService } from 'app/platform/lead/lead.service';

@Component({
  selector: 'app-noc-screen',
  templateUrl: './noc-screen.component.html',
  styleUrls: ['./noc-screen.component.css'],
  providers: [LeadService]
})
export class NocScreenComponent implements OnInit {

  constructor(
    private leadService: LeadService
  ) { }
  selectedTab = 'zero_to_forty';
  activeTab = "0-50%";
  ngOnInit() {
  }

  message;
  receiveMessage($event) {
    this.message = $event
  }
  amount;
  reciveAmount($event) {
    this.amount = $event;
  }
 

  activateTab(tab){
    this.selectedTab = tab;
    switch(tab){
      case "zero_to_forty":
        this.activeTab = "0-50%";
        break;
      case "forty_to_hundred":
        this.activeTab = "40-100%";
        break;
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/platform/organisation/noc-screen/noc-screen.component.ts